var render, staticRenderFns
import script from "./TStatusColorDot.vue?vue&type=script&lang=js&"
export * from "./TStatusColorDot.vue?vue&type=script&lang=js&"
import style0 from "./TStatusColorDot.vue?vue&type=style&index=0&id=521a9461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a9461",
  null
  
)

export default component.exports